var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"entity-metric",class:{ 'entity-metric--highlight': _vm.highlight }},[_c('div',{staticClass:"entity-metric__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"entity-metric__value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }